import type { ComponentMetaInput } from '../ui';

export const APP_RETURN_META: ComponentMetaInput = {
  id: 'app.nav.return',
  page: 'global',
  role: 'button',
  label: '返回',
  layout: { x: 19, y: 774, width: 44, height: 44 },
  zIndex: 20,
  notes: '独立功能页返回按钮；返回实际上一条应用内历史记录',
};

export const APP_FEATURE_TITLE_META: ComponentMetaInput = {
  id: 'app.nav.featureTitle',
  page: 'global',
  role: 'text',
  label: '当前功能名称',
  layout: { x: 75, y: 774, width: 296, height: 44 },
  zIndex: 20,
  props: ['title'],
  notes: '独立功能页底栏标题；与四个主导航按钮互斥显示',
};

export const APP_SKIN_BACKDROP_META: ComponentMetaInput = {
  id: 'app.skinBackdrop',
  page: 'global',
  role: 'background',
  label: '全站壁纸与毛玻璃背景',
  layout: { x: 0, y: 0, width: 390, height: 844 },
  zIndex: 1,
  props: ['clearWallpaper'],
  notes: '固定壁纸玻璃层；对话页清除玻璃以保持聊天壁纸清晰，其他页面统一使用',
};

/** Static manifest input; runtime title uses the same identity and logical coordinates. */
export const APP_CONTEXT_NAV_COMPONENTS: readonly ComponentMetaInput[] = [
  APP_RETURN_META,
  APP_FEATURE_TITLE_META,
];
